enum Mutations {
  SET_TRANSLATIONS = 'setTranslations',
  SWITCH_LANGUAGE = 'switchLanguage',
}

export default Mutations
